module.exports = __webpack_public_path__ + "static/img/upgrade.701bf8d3.png";